import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CustomerObject } from 'src/app/_interfaces/cinema/CustomerObject';
import { environment } from 'src/environments/environment';

const API_URL = environment.prismaApiUrl +'/api/dispo/team_bases';

@Injectable({
  providedIn: 'root'
})
export class TeamBaseService {
  currentObject: any;
  isNew: Boolean = false;

  constructor(private http: HttpClient) { }

  getAll(): Observable<any> {
    return this.http.get(API_URL);
  }

  getPlacementData(): Observable<any> {
    return this.http.get(API_URL + '/' + 'get-placment-data');
  }

  storeClassParams(id:any, object: any): Observable<any> {
    return this.http.post<CustomerObject>(API_URL + '/store-class-params/' + id, {data: object});
  }

  schedulerAllByDateRange(object: any): Observable<any> {
    return this.http.post<CustomerObject>(API_URL + '/scheduler-all-by-date-range', {data: object});
  }

  calendarAllByDateRange(object: any, $mode): Observable<any> {
    return this.http.post<CustomerObject>(API_URL + '/calendar-all-by-date-range', {data: object});
  }

  getOptCalendarByDateRange(object: any) : Observable<any> {
    return this.http.post<CustomerObject>(API_URL + '/get-opt-calendar-by-date-range', {data: object});
  }


  storeTeamLocations(id:any, object: any): Observable<any> {
    return this.http.post<CustomerObject>(API_URL + '/store-team-locations/' + id, {data: object});
  }

  updateDefaultWorkingTimes(id:any, object: any): Observable<any> {
    return this.http.post<CustomerObject>(API_URL + '/update-default-working-times/' + id, {data: object});
  }

  getFilter(): Observable<any> {
    return this.http.get(API_URL + '/filter');
  }

  search(string): Observable<any> {
    return this.http.get(API_URL + '/search/' + string);
  }

  export(): Observable<any> {
    return this.http.get(API_URL + '/export',{responseType: 'blob'});
  }

  send(): Observable<any> {
    return this.http.get(API_URL + '/send');
  }

  store(object: any): Observable<any> {
    return this.http.post<CustomerObject>(API_URL, {data: object});
  }

  delete(id: any): Observable<any> {
    return this.http.delete(API_URL + '/' + id);
  }

  show(id: any): Observable<any> {
    this.currentObject = this.http.get(API_URL + '/' + id);
    return this.currentObject;
  }

  update(object: any): Observable<any> {
    return this.http.put<CustomerObject>(API_URL + '/' + object.id, {data: object});
  }

  genPDF(object: any): Observable<any> {
    return this.http.get(API_URL + '/gen-pdf', {responseType: 'blob'});
  }

  getCurrentObject() {
    return this.currentObject;
  }

  setIsNew(value: any) {
    this.isNew = value;
  }

  getIsNew() {
    return this.isNew;
  }
}
